<template>
    <div class="my-container">
        <!-- Card Principal Integrado -->
        <div class="my-card">
            <!-- Header do DataTable -->
            <div class="my-header">
                <div class="header-left">
                    <h1 class="datatable-title">{{ crudName || 'Dados' }}</h1>
                    <span class="records-summary" v-if="cursorPagination">
                        {{ dataList && dataList.length ? dataList.length : 0 }} nesta página
                    </span>
                    <span class="records-summary" v-else>{{ count }} registro(s)</span>
                </div>
                <div class="header-right">
                    <button v-if="enableExtract" class="btn btn-outline-light bg-white btn-sm mobile-action-btn"
                        @click="openModalExtract" :disabled="extracting" title="Exportar Relatório">
                        <i class="fa fa-file-excel"></i>
                        <span class="d-none d-sm-inline-block">Exportar Relatório(E-mail)</span>
                    </button>
                    <router-link v-if="enableAdd" :to="endPoint + 'add'" class="btn btn-primary btn-datatable">
                        <i class="fa fa-plus"></i>
                        <span class="d-none d-sm-inline-block">{{ newText }}</span>
                    </router-link>
                </div>
            </div>

            <!-- Toolbar de Controles Integrado -->
            <div class="datatable-toolbar" v-if="loadingFilters">
                <!-- Toolbar quando filtros carregados -->
                <div class="toolbar-left">
                    <!-- Busca Global -->
                    <div class="global-search" v-if="filtersText && filtersText.length > 0">
                        <div class="search-input-wrapper">

                            <!-- Ações dos Filtros -->

                            <button type="button" class="btn btn-sm btn-primary" @click="buttonSearch(), get_data(1)"
                                :disabled="loading">
                                <i class="fa fa-search"></i>
                                Buscar
                            </button>

                            <button type="button" class="ml-2 btn btn-sm btn-outline-secondary" @click="clearAllFilters()"
                                :disabled="loading">
                                <i class="fa fa-eraser"></i>
                                Limpar Filtros
                            </button>

                        </div>
                    </div>

                    <!-- Filtros Rápidos -->
                    <div class="quick-filters" v-if="filtersRadio && filtersRadio.length > 0">
                        <div class="filter-tabs">
                            <button v-for="(filterRadio, index) in filtersRadio" :key="'filterRadio-' + index"
                                :class="['filter-tab', { active: filterRadio.checked }]"
                                @click="checkFilter(filterRadio)" :disabled="loading">
                                {{ filterRadio.label }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="toolbar-right">
                    <!-- Ordenação Compacta -->
                    <div class="sort-control" v-if="orderList && orderList.length > 0">
                        <select class="form-select sort-select" @input="changeOrderField($event)" :disabled="loading">
                            <template v-for="(orderOption, index) in orderList" :key="'order-' + index">
                                <option :value="orderOption.column" v-if="orderOption.selected" selected>
                                    {{ orderOption.name }}
                                </option>
                                <option :value="orderOption.column" v-else>
                                    {{ orderOption.name }}
                                </option>
                            </template>
                        </select>
                        <button class="btn btn-outline-secondary sort-direction" @click="toggleSortDirection"
                            :disabled="loading" :title="orderType === 'ASC' ? 'Crescente' : 'Decrescente'">
                            <i :class="['fa', orderType === 'ASC' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"></i>
                        </button>
                    </div>

                    <!-- Filtros Avançados -->
                    <div class="advanced-filters">
                        <button class="btn btn-sm btn-outline-primary filters-toggle" @click="toggleAdvancedFilters"
                            :class="{ active: showAdvancedFilters }">
                            <i class="fa fa-filter"></i>
                            Filtros
                            <span class="filter-count" v-if="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
                        </button>
                    </div>

                    <!-- Controles de Ações -->
                    <div class="action-controls">
                        <button v-if="enableSaveColumns && configColumnsLoaded" class="btn btn-sm btn-outline-secondary"
                            @click="openModalColumns" title="Configurar Colunas">
                            <i class="fa fa-cog"></i>
                        </button>
                        <!-- <button v-if="enableExtract" class="btn btn-success" @click="openModalExtract"
                            :disabled="extracting" title="Exportar Relatório">
                            <i class="fa fa-file-excel"></i> Exportar Relatório
                        </button> -->
                    </div>
                </div>
            </div>

            <!-- Toolbar Placeholder durante carregamento inicial -->
            <div class="datatable-toolbar toolbar-placeholder" v-else>
                <div class="toolbar-left">
                    <div class="global-search">
                        <div class="search-input-wrapper">
                            <i class="fa fa-search search-icon"></i>
                            <input type="text" class="form-control search-input" placeholder="Carregando filtros..."
                                disabled />
                        </div>
                    </div>
                </div>
                <div class="toolbar-right">
                    <div class="action-controls">
                        <button class="btn btn-outline-secondary" disabled>
                            <i class="fa fa-cog"></i>
                        </button>
                        <button class="btn btn-success" disabled>
                            <i class="fa fa-file-excel"></i> Exportar Relatório
                        </button>
                    </div>
                </div>
            </div>


            <!-- Filtros Avançados Expandíveis -->
            <div class="advanced-filters-panel" v-if="showAdvancedFilters">
                <div class="filters-grid">
                    <!-- Filtros de Texto -->
                    <template v-for="(filterText, index) in filtersText" :key="'filtersText-' + index">
                        <div class="filter-group">
                            <label class="filter-label">{{ filterText.label }}</label>
                            <input type="text" :id="'text' + index" class="form-control filter-input"
                                v-model="filterText.value" @change="changeFilter(filterText.name, $event)"
                                @keyup.enter="changeFilter(filterText.name, $event), get_data(1)" :disabled="loading"
                                :placeholder="`Buscar ${filterText.label.toLowerCase()}...`" />
                        </div>
                    </template>

                    <!-- Contratos -->
                    <template v-for="(filterContract, index) in filtersContract" :key="'filtersContract-' + index">
                        <div class="filter-group" v-if="contracts.length > 0">
                            <label class="filter-label">{{ filterContract.label }}</label>
                            <select class="form-select filter-select"
                                @change="changeFilter(filterContract.name, $event)" :disabled="loading"
                                :id="'contract' + index" v-model="filterContract.value">
                                <option value="">Todos</option>
                                <option v-for="contract in contracts" :key="contract" :value="contract">
                                    {{ contract }}
                                </option>
                            </select>
                        </div>
                    </template>

                    <!-- Produtos -->
                    <template v-for="(filterProduct, index) in filtersProduct" :key="'filtersProduct-' + index">
                        <div class="filter-group" v-if="products.length > 0">
                            <label class="filter-label">{{ filterProduct.label }}</label>
                            <select class="form-select filter-select" @change="changeFilter(filterProduct.name, $event)"
                                :disabled="loading" :id="'product' + index" v-model="filterProduct.value">
                                <option value="">Todos</option>
                                <option v-for="prod in products" :key="prod.trim()" :value="prod.trim()">
                                    {{ prod.trim() }}
                                </option>
                            </select>
                        </div>
                    </template>

                    <!-- Filiais -->
                    <template v-for="(filterBranch, index) in filtersBranch" :key="'filtersBranch-' + index">
                        <div class="filter-group" v-if="branches.length > 0">
                            <label class="filter-label">{{ filterBranch.label }}</label>
                            <select class="form-select filter-select" @change="changeFilter(filterBranch.name, $event)"
                                :disabled="loading" :id="'branch' + index" v-model="filterBranch.value">
                                <option value="">Todas</option>
                                <option v-for="branch in branches" :key="branch" :value="branch.filial">
                                    {{ branch.nomefil }}
                                </option>
                            </select>
                        </div>
                    </template>

                    <!-- Tipos de Usuário -->
                    <template v-for="(filterType, index) in filtersUsersType" :key="'filterType-' + index">
                        <div class="filter-group">
                            <label class="filter-label">{{ filterType.label }}</label>
                            <select class="form-select filter-select" @change="changeFilter(filterType.name, $event)"
                                :disabled="loading">
                                <option value="">Todos</option>
                                <option value="4">Administrador Master</option>
                                <option value="1">Administrador</option>
                                <option value="2">Cliente</option>
                                <option value="3">Usuário Interno</option>
                            </select>
                        </div>
                    </template>

                    <!-- Filtros de Data -->
                    <template v-if="filtersDate && filtersDate.length > 0">
                        <template v-for="(filterDate, index) in filtersDate" :key="'filtersDate-' + index">
                            <div class="filter-group">
                                <label class="filter-label">{{ filterDate.label }}</label>
                                <input type="text" :id="'date' + index" v-maska="'##/##/####'"
                                    class="form-control filter-input" @change="changeFilter(filterDate.name, $event)"
                                    @keyup.enter="changeFilter(filterDate.name, $event), get_data(1)" :disabled="loading"
                                    placeholder="DD/MM/AAAA" />
                            </div>
                        </template>
                    </template>

                    <!-- Filtros Select API -->
                    <template v-if="filtersSelectApi && filtersSelectApi.length > 0">
                        <template v-for="(select, index) in selApi" :key="'filtersSelectApi-' + index">
                            <div class="filter-group">
                                <label class="filter-label" v-if="vSelect">{{ select.element.label }}</label>
                                <v-select class="filter-vselect" v-if="vSelect" :clearable="false"
                                    :reduce="(option) => option[select.element.propertyValue]" :id="'select' + index"
                                    :label="[select.element.propertyName]" :options="select.data"
                                    @option:selected="changeFilterSelect(select.element.name, $event, select.element.propertyValue)">
                                </v-select>
                            </div>
                        </template>
                    </template>
                </div>


            </div>


            <!-- Área de Conteúdo Unificada -->
            <div class="datatable-main-content">
                <!-- Loading State -->


                <!-- Tabela Principal -->
                <div class="datatable-content">
                    <!-- Alert de Colunas Ocultas -->
                    <div class="hidden-columns-alert" v-if="other_columns.length > 0">
                        <i class="fa fa-eye-slash"></i>
                        <span>{{ other_columns.length }} coluna(s) oculta(s)</span>
                        <button @click="openModalColumns" class="btn-link">Configurar colunas</button>
                    </div>

                    <!-- Informação de rolagem para mobile -->
                    <div class="mobile-scroll-helper" v-if="isMobileDevice">
                        <i class="fa fa-arrows-h"></i>
                        <span>Deslize a tabela horizontalmente para ver todos os dados</span>
                    </div>

                    <!-- Wrapper da Tabela -->
                    <div class="table-responsive">
                        <table class="datatable" v-if="showTable">
                            <thead class="my-header-row">
                                <tr>
                                    <th class="datatable-th" v-for="(column, index) in local_columns"
                                        :key="'column-' + index">
                                        {{ column.label }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="dataList && dataList.length > 0">
                                <tr v-for="(row, index) in dataList" :key="'row-' + index" class="datatable-row">
                                    <td v-for="(column, indexCol) in local_columns" :key="'column-index-' + indexCol"
                                        class="datatable-td">
                                        <!-- Botões -->
                                        <div v-if="column.type && column.type == 'button'">
                                            <div v-if="column.conditionShow(row)">
                                                <button :disabled="column.condition(row)"
                                                    v-show="column.conditionShow(row)" :class="column.class"
                                                    @click="buttonCallback(column, row)">
                                                    {{ column.label }}
                                                </button>
                                            </div>
                                            <span v-else class="na-value">—</span>
                                        </div>

                                        <!-- Botões com Label -->
                                        <div v-else-if="column.type && column.type == 'buttonLabel'">
                                            <div v-if="column.conditionShow(row)">
                                                <button :disabled="column.condition(row)"
                                                    v-show="column.conditionShow(row)"
                                                    :class="getButtonClass(column, row)"
                                                    @click="buttonCallback(column, row)">
                                                    <i v-if="needsIcon(column, row)" class="fa fa-download"></i>
                                                    <span v-else>{{ column.labelCallback(row) }}</span>
                                                </button>
                                            </div>
                                            <span v-else class="na-value">—</span>
                                        </div>

                                        <!-- Método de Pagamento -->
                                        <div v-else-if="column.type && column.type == 'payment_method'">
                                            <div v-if="column.conditionShow(row)">
                                                <span :class="getPaymentClass(column, row)"
                                                    @click="buttonCallback(column, row)">
                                                    {{ column.labelCallback(row) }}
                                                </span>
                                            </div>
                                            <span v-else class="na-value">—</span>
                                        </div>

                                        <!-- Campo Clicável -->
                                        <div v-else-if="column.type && column.type == 'fieldClickable'">
                                            <span class="clickable-field" v-html="get_field_value(column, row)"
                                                @click="buttonCallback(column, row)"></span>
                                        </div>

                                        <!-- Campo Normal -->
                                        <div v-else class="field-value">
                                            <span v-html="get_field_value(column, row)"></span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="!loading && dataList && dataList.length == 0">
                                <tr>
                                    <td :colspan="local_columns.length" class="text-center ">
                                        <span class="empty-content">
                                            <i class="fa fa-inbox empty-icon"></i>
                                            <h4>Nenhum resultado encontrado</h4>
                                            <p>Tente ajustar os filtros ou refazer a busca</p>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-if="loading">
                                <tr>
                                    <td :colspan="local_columns.length" class="text-center">
                                        <span class="mt-3 fa fa-spinner fa-spin fa-5x"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Footer Unificado -->
            <div class="datatable-footer" :class="{ 'footer-placeholder': loading }">
                <div class="footer-left">
                    <div class="items-per-page">
                        <label>Registros por página:</label>
                        <select class="form-select page-size-select" @change="setCtop($event)" :disabled="loading">
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="25" selected>25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="footer-center">
                    <div class="pagination-info">
                        <span v-if="loading">Carregando...</span>
                        <span v-else-if="cursorPagination">Página {{ currentPage + 1 }}</span>
                        <span v-else-if="dataList && dataList.length > 0">
                            {{ (currentPage * cTop) + 1 }}–{{ Math.min((currentPage + 1) * cTop, count) }} de {{ count
                            }}
                        </span>
                        <span v-else>0 de 0</span>
                    </div>
                </div>
                <div class="footer-right">
                    <nav class="pagination-nav" v-if="!loading && cursorPagination">
                        <button type="button" class="pagination-btn" @click="get_data(currentPage)"
                            :disabled="!hasPrev" title="Página anterior">
                            <i class="fa fa-angle-left"></i>
                        </button>
                        <span class="pagination-pages">
                            <template v-for="pageNum in cursorPageList" :key="'cursor-page-' + pageNum">
                                <button type="button" class="pagination-btn page-number"
                                    :class="{ active: pageNum === currentPage + 1 }" @click="get_data(pageNum)">
                                    {{ pageNum }}
                                </button>
                            </template>
                        </span>
                        <button type="button" class="pagination-btn" @click="get_data(currentPage + 2)"
                            :disabled="!hasNext" title="Próxima página">
                            <i class="fa fa-angle-right"></i>
                        </button>
                    </nav>
                    <nav class="pagination-nav" v-else-if="!loading && lastPage > 1">
                        <button class="pagination-btn" @click="get_data(1)" :disabled="currentPage <= 0"
                            title="Primeira página">
                            <i class="fa fa-angle-double-left"></i>
                        </button>
                        <button class="pagination-btn" @click="get_data(currentPage)"
                            :disabled="currentPage <= 0" title="Página anterior">
                            <i class="fa fa-angle-left"></i>
                        </button>

                        <span class="pagination-pages">
                            <template v-for="page in paginationPages" :key="page">
                                <button v-if="page !== '...'" class="pagination-btn page-number"
                                    :class="{ active: page === currentPage + 1 }" @click="get_data(page)">
                                    {{ page }}
                                </button>
                                <span v-else class="pagination-ellipsis">...</span>
                            </template>
                        </span>

                        <button class="pagination-btn" @click="get_data(currentPage + 2)"
                            :disabled="currentPage + 1 >= lastPage" title="Próxima página">
                            <i class="fa fa-angle-right"></i>
                        </button>
                        <button class="pagination-btn" @click="get_data(lastPage)"
                            :disabled="currentPage + 1 >= lastPage" title="Última página">
                            <i class="fa fa-angle-double-right"></i>
                        </button>
                    </nav>
                    <nav class="pagination-nav" v-else-if="loading">
                        <button class="pagination-btn" disabled>
                            <i class="fa fa-angle-double-left"></i>
                        </button>
                        <button class="pagination-btn" disabled>
                            <i class="fa fa-angle-left"></i>
                        </button>
                        <button class="pagination-btn page-number" disabled>1</button>
                        <button class="pagination-btn" disabled>
                            <i class="fa fa-angle-right"></i>
                        </button>
                        <button class="pagination-btn" disabled>
                            <i class="fa fa-angle-double-right"></i>
                        </button>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Colunas (mantido igual) -->
    <div id="modalColumns" v-if="configColumnsLoaded">
        <div class="modal-fade-background"></div>
        <div :class="['modal fade show']" id="modal-pending" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div id="modalColumns">
                        <div class="row">
                            <div class="col-md-6 bold">Ajustar Colunas</div>
                            <div class="col-md-6">
                                <button @click="closeModalColumns()" style="
                  padding: 15px;
                  width: 30px;
                  margin-right: 10px;
                  padding: 0px;
                " class="btn btn-danger float-right">
                                    X
                                </button>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <div class="alert alert-primary" role="alert">
                                    Aqui você pode ocultar e organizar as colunas que serão
                                    exibidas na tabela abaixo, vale lembrar que estas
                                    configurações ficarão salvas em seu login.
                                </div>
                            </div>
                            <div class="col-md-6" v-if="showTable">
                                <div class="centered bold fs-16">Exibir</div>
                                <draggable class="dragArea list-group w-full " v-model="local_columns_"
                                    ghost-class="ghost" :move="checkMove" group="collumns"
                                    @change="handleAddToOtherColumns">

                                    <div class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center bordered"
                                        v-for="element in local_columns_" :key="element.label">
                                        <svg data-v-0469d702="" data-v-2fc82866-s="" data-v-2fb1486c-s=""
                                            class="svg-inline--fa fa-arrows-alt fa-w-16" aria-hidden="true"
                                            focusable="false" data-prefix="fa" data-icon="arrows-alt" role="img"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path class="" fill="currentColor"
                                                d="M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z">
                                            </path>
                                        </svg>
                                        {{ element.label }}
                                    </div>

                                </draggable>
                            </div>
                            <div class="col-md-6" v-if="showTable">
                                <div class="centered bold fs-16">Não Exibir</div>
                                <draggable class="dragArea list-group w-full " v-model="other_columns_"
                                    ghost-class="ghost" :move="checkMove" group="collumns"
                                    @change="handleRemoveFromOtherColumns">
                                    <div class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center bordered"
                                        v-for="element in other_columns_" :key="element.label">
                                        <svg data-v-0469d702="" data-v-2fc82866-s="" data-v-2fb1486c-s=""
                                            class="svg-inline--fa fa-arrows-alt fa-w-16" aria-hidden="true"
                                            focusable="false" data-prefix="fa" data-icon="arrows-alt" role="img"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path class="" fill="currentColor"
                                                d="M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z">
                                            </path>
                                        </svg>
                                        {{ element.label }}
                                    </div>

                                </draggable>
                            </div>

                        </div>
                        <div class="row mt-5">
                            <div class="col text-end">
                                <button class="btn btn-info m-1" @click="confirmReset">
                                    Resetar
                                </button>
                                <button class="btn btn-danger m-1" @click="closeModalColumns">
                                    Fechar
                                </button>
                                <button class="btn btn-success m-1" @click="saveColumns()">
                                    Salvar Colunas
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
// import Draggable from "vue3-draggable";
import { VueDraggableNext } from 'vue-draggable-next'
import Toggle from "@vueform/toggle";
import env from "../../env.js";
import { applyErpPagination } from "../../helpers/erpPagination.js";

export default {
    data() {
        return {
            isAmbientaly: env.isAmbientaly,
            showTable: true,
            configColumnsLoaded: false,
            dragOptions: {
                group: "columns",
            },
            local_columns: [],
            other_columns: [],
            local_columns_: [],
            other_columns_: [],
            extract_data: {
                email: "",
            },
            simNao: {
                onLabel: "SIM",
                offLabel: "NÃO",
            },
            filters_new: [],
            products: [],
            contracts: [],
            branches: [],
            buttonSearchClicked: false,
            show_retry_button: false,
            selArray: [],
            selApi: {},
            selectedOrder: "",
            orderType: "DESC",
            data: [],
            ordered_index: "",
            ordered_by: "",
            extracting: false,
            ordered_asc: true,
            currentPage: 0,
            firstPage: 1,
            lastPage: 0,
            cursorPagination: false,
            hasNext: false,
            hasPrev: false,
            maxPageReached: 1,
            count: 0,
            loading: true,
            loadingFilters: true,
            requesting: false,
            vSelect: true,
            clearFiltersTmp: [],
            cTop: 25,
            filters_copy: [],
            // Novas variáveis para o DataTable integrado
            showAdvancedFilters: false,
            globalSearchValue: "",
            globalSearchTimeout: null,
            isMobileDevice: false, // Para detectar dispositivos móveis
            _originalColumns: null,
            _mobileOptimized: false,
            _hiddenForMobile: [],
        };
    },
    components: { vSelect, draggable: VueDraggableNext, Toggle },
    computed: {
        orderList() {
            return this.orders;
        },
        dataList() {
            return this.data;
        },
        filtersRadio() {
            return this.filters_copy.filter(function (item) {
                return item.type == "radio";
            });
        },
        filtersText() {
            return this.filters_copy.filter(function (item) {
                return item.type == "text";
            });
        },
        filtersDate() {
            return this.filters_copy.filter(function (item) {
                return item.type == "date";
            });
        },
        filtersSelectApi() {
            return this.filters_copy.filter(function (item) {
                return item.type == "selectApi";
            });
        },
        filtersContract() {
            return this.filters_copy.filter(function (item) {
                return item.type == "contract";
            });
        },
        filtersProduct() {
            return this.filters_copy.filter(function (item) {
                return item.type == "product";
            });
        },
        filtersBranch() {
            return this.filters_copy.filter(function (item) {
                return item.type == "branch";
            });
        },
        filtersUsersType() {
            return this.filters_copy.filter(function (item) {
                return item.type == "user_type";
            });
        },
        hasAnyFilters() {
            return this.filtersText.length > 0 ||
                this.filtersDate.length > 0 ||
                this.filtersSelectApi.length > 0 ||
                (this.filtersContract.length > 0 && this.contracts.length > 0) ||
                (this.filtersProduct.length > 0 && this.products.length > 0) ||
                (this.filtersBranch.length > 0 && this.branches.length > 0) ||
                this.filtersUsersType.length > 0;
        },
        activeFiltersCount() {
            let count = 0;

            // Contar apenas filtros que aparecem no painel avançado
            // Filtros de texto
            this.filtersText.forEach(filter => {
                if (filter.value && filter.value.trim() !== '') {
                    count++;
                }
            });

            // Filtros de data
            this.filtersDate.forEach(filter => {
                if (filter.value && filter.value.trim() !== '') {
                    count++;
                }
            });

            // Filtros de contratos (apenas se há contratos disponíveis)
            if (this.contracts.length > 0) {
                this.filtersContract.forEach(filter => {
                    if (filter.value && filter.value.trim() !== '') {
                        count++;
                    }
                });
            }

            // Filtros de produtos (apenas se há produtos disponíveis)
            if (this.products.length > 0) {
                this.filtersProduct.forEach(filter => {
                    if (filter.value && filter.value.trim() !== '') {
                        count++;
                    }
                });
            }

            // Filtros de filiais (apenas se há filiais disponíveis)
            if (this.branches.length > 0) {
                this.filtersBranch.forEach(filter => {
                    if (filter.value && filter.value.trim() !== '') {
                        count++;
                    }
                });
            }

            // Filtros de tipos de usuário
            this.filtersUsersType.forEach(filter => {
                if (filter.value && filter.value.trim() !== '') {
                    count++;
                }
            });

            // Filtros de Select API
            this.filtersSelectApi.forEach(filter => {
                if (filter.value && filter.value.trim() !== '') {
                    count++;
                }
            });

            return count;
        },
        cursorPageList() {
            return Array.from({ length: this.maxPageReached }, (_, i) => i + 1);
        },
        paginationPages() {
            const pages = [];
            const total = this.lastPage;
            const current = this.currentPage + 1;

            if (total <= 7) {
                // Se tem 7 páginas ou menos, mostra todas
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
            } else {
                // Lógica para páginas com ellipsis
                if (current <= 4) {
                    // Próximo do início
                    for (let i = 1; i <= 5; i++) {
                        pages.push(i);
                    }
                    pages.push('...');
                    pages.push(total);
                } else if (current >= total - 3) {
                    // Próximo do fim
                    pages.push(1);
                    pages.push('...');
                    for (let i = total - 4; i <= total; i++) {
                        pages.push(i);
                    }
                } else {
                    // No meio
                    pages.push(1);
                    pages.push('...');
                    for (let i = current - 1; i <= current + 1; i++) {
                        pages.push(i);
                    }
                    pages.push('...');
                    pages.push(total);
                }
            }

            return pages;
        }
    },
    props: {
        colorBar: String,
        enableExtract: Boolean,
        ref: String,
        filters: Array,
        crudName: String,
        styleHeader: String,
        newText: String,
        table: String,
        endPoint: String,
        enableAdd: Boolean,
        enableEdit: Boolean,
        enableDelete: Boolean,
        layoutNames: Array,
        relationships: Array,
        extras: Array,
        orders: Array,
        columns: Array,
        enableSaveColumns: {
            type: Boolean,
            default: false,
        },
        increments: {
            type: String,
            default: "",
        },
    },
    methods: {
        confirmReset() {
            this.$swal
                .fire({
                    title: "Tem certeza fazer isto?",
                    text: "As configurações de colunas retornarão ao padrão inicial.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.resetColumns(this.$router.currentRoute.value.path);
                    }
                });
        },
        resetColumns() {
            this.showTable = false
            console.log(this.$store.state.columns)
            const self = this;
            const api = this.$store.state.api + "users/delete_columns";

            self.loading = true;
            const endpoint = self.$router.currentRoute.value.path;

            var obj = {
                endpoint: endpoint,
            };
            axios
                .post(api, obj)
                .then((response) => {
                    self.loading = false;
                    self.$toast.success("A ordem das colunas resetada.");
                    // self.get_data(1);
                    window.location = window.location;

                    self.local_columns = self.local_columns_ = self.columns;
                    self.other_columns = [];
                    self.other_columns_ = [];

                    console.log(self.$store.state.columns)
                    delete self.$store.state.columns[endpoint];

                    console.log(self.$store.state.columns)

                })
                .then(() => {
                    self.getColumns()
                    self.closeModalColumns()
                    self.showTable = true
                })
                .catch((error) => {
                    self.$toast.error("Erro na API");
                    self.loading = false;
                    self.showTable = true
                });
        },
        saveColumns() {
            const self = this;
            const api = this.$store.state.api + "users/save_columns";
            this.showTable = false

            self.loading = true;

            var obj = {
                show: JSON.stringify(self.local_columns_),
                no_show: JSON.stringify(self.other_columns_),
                endpoint: self.$router.currentRoute.value.path,
            };
            self.closeModalColumns();

            axios
                .post(api, obj)
                .then((response) => {
                    self.loading = false;
                    self.$toast.success("A ordem das colunas foi salva.");
                    // self.get_data(1);
                    window.location = window.location;

                    setTimeout(function () {
                        self.local_columns = self.local_columns_;
                        self.other_columns = self.other_columns_;
                        // window.location = window.location;
                        self.showTable = true
                    }, 2000);

                })
                .catch((error) => {
                    self.$toast.error("Erro na API");
                    self.loading = false;
                    self.showTable = true
                });
        },
        getColumns() {
            const self = this;
            self.configColumnsLoaded = false;
            const endpoint = self.$router.currentRoute.value.path;
            self.local_columns_ = self.local_columns;
            self.other_columns_ = self.other_columns;
            self.loading = false;
            
            // Verificar se precisa ajustar colunas para mobile após carregar as colunas
            setTimeout(() => {
                if (self.isMobileDevice && !self._mobileOptimized) {
                    self.detectMobileDevice();
                }
            }, 100);

            console.log('getcolumns: ' + this.$store.state.columns[endpoint])
            if (this.$store.state.columns[endpoint]) {

                var no_show = JSON.parse(this.$store.state.columns[endpoint].no_show);
                var show = JSON.parse(this.$store.state.columns[endpoint].show);

                console.log(no_show)
                console.log(show)

                no_show.forEach((element) => {
                    self.local_columns.forEach((local, index) => {
                        if (local.label == element.label) {
                            self.other_columns.push(local);
                            self.local_columns.splice(index, 1);
                        }
                    });
                });
                var new_order = [];
                show.forEach((element, index) => {
                    self.local_columns.forEach((local, index) => {
                        console.log('entrou no terceiro if')
                        if (local.label == element.label) {
                            new_order.push(local);
                        }
                    });
                });

                self.local_columns = self.local_columns_ = new_order;
                self.other_columns_ = self.other_columns;
            }
            self.configColumnsLoaded = true;
        },
        checkMove(event) {
            console.log('checkMove', event.draggedContext)
            console.log('Future index: ' + event.draggedContext.futureIndex)
        },
        handleAddToOtherColumns(event) {
            const { moved, added } = event

            if (moved) console.log('moved', moved)
            if (added) console.log('added', added, added.element)


            // debugger
            // this.other_columns_.push(event.moved.element);
            // this.local_columns_.splice(event.moved.oldIndex, 1);
        },
        handleRemoveFromOtherColumns(event) {
            const { moved, added } = event

            if (moved) console.log('moved', moved)
            if (added) console.log('added', added, added.element)
            // debugger
            // this.local_columns_.push(event.moved.element);
            // this.other_columns_.splice(event.moved.oldIndex, 1);
        },
        openModalColumns() {
            const self = this;

            show_modal("modalColumns");
        },
        closeModalColumns() {
            close_modal("modalColumns");
        },
        openModalExtract() {
            this.$swal
                .fire({
                    title: "Atenção!",
                    text: " Este relatório pode levar alguns minutos para ficar pronto, assim que o processo for encerrado será enviado o arquivo ao seu e-mail de cadastro, deseja continuar?",
                    // icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.extract();
                    }
                });
        },
        setCtop(value) {
            const self = this;
            this.cTop = value.target.value;

            setTimeout(function () {
                $("#show_registers").val(self.cTop).change();
            }, 2000);
            this.get_data(1);
        },
        buttonSearch() {
            this.buttonSearchClicked = true;
        },
        changeFilterSelect(field, value, column) {
            this.filters_copy.forEach(function (filterText) {
                if (filterText.name == field) {
                    filterText.value = value[column];
                }
            });
            window.localStorage.setItem('filters_' + this.crudName, JSON.stringify(this.filters_copy))
        },
        clearFilters() {

            window.localStorage.removeItem('filters_' + this.crudName);

            const self = this;
            self.vSelect = false;
            var i = 0;
            this.filtersText.forEach((el) => {
                $("#text" + i).val("");
                i++;
            });

            var j = 0;
            this.filtersDate.forEach((el) => {
                $("#date" + j).val("");
                j++;
            });

            var j = 0;
            this.filtersProduct.forEach((el) => {
                $("#product" + j).val("");
                j++;
            });

            var j = 0;
            this.filtersBranch.forEach((el) => {
                setTimeout(function () {
                    $("#branch0").val("");
                }, 3000);
                j++;
            });

            var j = 0;
            this.filtersContract.forEach((el) => {
                $("#contract" + j).val("");
                j++;
            });

            var k = 0;
            this.selArray.forEach((el) => {
                el = "";
            });

            this.filtersRadio.forEach((el) => {
                if (el.type != 'hidden') {
                    el.checked = false;
                }
            });

            var i = 0;
            this.filters_copy.forEach((el) => {
                if (el.type == "radio" && i == 0) {
                    el.checked = true;
                }

                if (el.type != "radio") {
                    el.value = "";
                }

                i++;
            });
            self.$store.dispatch("setQueryHistory", {
                route: null,
                query: null,
            });
            self.$store.dispatch("setSearchHistory", { have: false, filters: {} });
            this.filters_copy = JSON.parse(JSON.stringify(this.filters));
            this.get_data(1);
        },
        changeFilter(field, value) {
            this.filters_copy.forEach(function (filterText) {
                if (filterText.name == field) {
                    filterText.value = value.target.value;
                }
            });
            window.localStorage.setItem('filters_' + this.crudName, JSON.stringify(this.filters_copy))
        },
        changeOrderField(field) {
            this.selectedOrder = field.target.value;
        },
        changeOrder(value) {
            this.orderType = value;
        },
        buttonCallback(column, row) {
            this.$emit(column.callbackFunction, row);
        },
        checkFilter(checkedFilter) {
            this.filtersRadio.forEach(function (filter) {
                filter.checked = false;
            });

            checkedFilter.checked = true;

            this.get_data(1);
        },
        async get_data(page = 1) {
            const self = this;

            await new Promise((r) => setTimeout(r, 500));

            self.show_retry_button = false;

            setTimeout(function () {
                self.show_retry_button = true;
            }, 30000);

            if (
                self.$store.state.queryHistory.query !== null &&
                self.$route.name === self.$store.state.queryHistory.route
            ) {
            } else {
                self.$store.dispatch("setSearchHistory", {
                    have: false,
                    filters: {},
                });
            }

            if (self.requesting == false) {
                self.data = [];

                self.loading = true;
                self.requesting = true;
                if (page < 1) {
                    page = 1;
                }
                var pg = page;
                const previousPage = self.currentPage;

                if (page <= 1) {
                    self.maxPageReached = 1;
                }

                if (!self.cursorPagination && self.lastPage > 0) {
                    if (pg > self.lastPage) {
                        self.loading = false;
                        self.requesting = false;
                        return;
                    }
                    if (pg < self.firstPage) {
                        self.loading = false;
                        self.requesting = false;
                        return;
                    }
                }

                var haveFilters = false;

                var query = "";

                if (self.$store.state.searchHistory.have) {
                    //Aqui devolve aos filtros o valor de cada um recuperado da store

                    setTimeout(function () {
                        // setar um timeout para dar tempo de carregar os elementos
                        var history_filters = JSON.parse(
                            JSON.stringify(self.$store.state.searchHistory.filters)
                        );

                        console.log("historico de filtros", history_filters);

                        //Text
                        var t = 0;
                        history_filters
                            .filter(function (item) {
                                return item.type == "text";
                            })
                            .forEach((element) => {
                                $("#text" + t).val(element.value);
                                t++;
                            });

                        //date
                        var d = 0;
                        history_filters
                            .filter(function (item) {
                                return item.type == "date";
                            })
                            .forEach((element) => {
                                $("#date" + d).val(element.value);
                                d++;
                            });

                        //product
                        var p = 0;
                        history_filters
                            .filter(function (item) {
                                return item.type == "product";
                            })
                            .forEach((element) => {
                                $("#product" + p).val(element.value);
                                p++;
                            });

                        //select
                        setTimeout(function () {
                            var s = 0;
                            history_filters
                                .filter(function (item) {
                                    return item.type == "selectApi";
                                })
                                .forEach((element) => {
                                    if (element.value != "" && element.value != undefined) {
                                        self.filtersSelectApi[s].value = element.value;
                                    }
                                    s++;
                                });
                        }, 5000);
                    }, 1000);
                }

                //monta os primeiros filtros ao abrir a tela
                self.filters_copy.forEach((filter) => {
                    if (filter.type == "radio" && filter.checked) {
                        query += "&" + filter.name + "=" + filter.value;

                        console.log("query", query);
                    } else if (
                        filter.type == "date" &&
                        filter.value != "" &&
                        filter.value != undefined
                    ) {
                        var vle = moment(filter.value, "DD/MM/YYYY").format("YYYY-MM-DD");

                        if (
                            filter.name == "created_at" &&
                            [
                                "users/",
                                "customers/",
                                "time_logs/",
                                "licitations/",
                                "orders-not-integrateds/",
                            ].includes(self.endPoint)
                        ) {
                            vle = vle + " 00:00:00," + vle + " 23:59:59";
                        }

                        haveFilters = true;

                        query += "&" + filter.name + "=" + vle;
                    } else if (
                        filter.type != "radio" &&
                        filter.value != "" &&
                        filter.value != undefined
                    ) {
                        haveFilters = true;

                        query += "&" + filter.name + "=" + filter.value;
                    }
                });

                if (
                    self.selectedOrder != "" &&
                    [
                        "users/",
                        "customers/",
                        "time_logs/",
                        "licitations/",
                        "orders-not-integrateds/",
                    ].includes(self.endPoint)
                ) {
                    if (self.orderType == "ASC") {
                        query += "&orderByAsc=" + self.selectedOrder;
                    } else {
                        query += "&orderByDesc=" + self.selectedOrder;
                    }
                }
                if (["log_access/"].includes(self.endPoint)) {
                    query += "&show_routes=1";
                }

                if (
                    self.selectedOrder != "" &&
                    !["log_access/"].includes(self.endPoint)
                ) {
                    query +=
                        "&order_by=" + self.selectedOrder + "&order_type=" + self.orderType;
                }
                if (["log_access/"].includes(self.endPoint)) {
                    query += "&orderByDesc=id";
                }

                self.relationships.forEach((relationship) => {
                    query += "&with[]=" + relationship;
                });

                self.extras.forEach((extra) => {
                    query += "&" + extra;
                });

                if (haveFilters) {
                    self.$store.dispatch("setQueryHistory", {
                        route: self.$route.name,
                        query: query,
                    });

                    self.$store.dispatch("setSearchHistory", {
                        have: true,
                        filters: self.filters_copy,
                    });
                }

                if (!haveFilters && self.buttonSearchClicked) {
                    self.$store.dispatch("setQueryHistory", {
                        route: null,
                        query: null,
                    });

                    self.$store.dispatch("setSearchHistory", {
                        have: false,
                        filters: {},
                    });
                }

                if (!haveFilters && self.selectedOrder == "") {
                    self.buttonSearchClicked = false;
                }

                if (
                    self.$store.state.queryHistory.query !== null &&
                    self.$route.name === self.$store.state.queryHistory.route
                ) {
                    query = self.$store.state.queryHistory.query;
                } else {
                    self.$store.dispatch("setQueryHistory", {
                        route: null,
                        query: null,
                    });

                    self.$store.dispatch("setSearchHistory", {
                        have: false,
                        filters: {},
                    });
                }

                if (
                    [
                        "users/",
                        "customers/",
                        "time_logs/",
                        "licitations/",
                        "orders-not-integrateds/",
                        "log_access/",
                    ].includes(self.endPoint)
                ) {
                    if (haveFilters) {
                        var api =
                            self.$store.state.api +
                            self.endPoint +
                            "?page=" +
                            page +
                            "&" +
                            query +
                            "&limit=" +
                            100 +
                            self.increments;
                    } else {
                        var api =
                            self.$store.state.api +
                            self.endPoint +
                            "?page=" +
                            page +
                            "&" +
                            query +
                            "&limit=" +
                            self.cTop +
                            self.increments;
                    }
                } else {
                    var api =
                        self.$store.state.api +
                        self.endPoint +
                        "?page=" +
                        page +
                        "&" +
                        query +
                        "&cTop=" +
                        self.cTop +
                        self.increments;
                }

                axios
                    .get(api)
                    .then((response) => {
                        setTimeout(function () {
                            $("#show_registers").val(self.cTop).change();
                        }, 1000);
                        if (
                            [
                                "users/",
                                "customers/",
                                "time_logs/",
                                "licitations/",
                                "orders-not-integrateds/",
                                "log_access/",
                            ].includes(self.endPoint)
                        ) {
                            self.data = Object.values(response.data.data);
                            self.count = response.data.count;
                            self.currentPage = response.data.page;
                            self.lastPage = response.data.pages;
                            self.cursorPagination = false;
                        } else {
                            applyErpPagination(
                                self,
                                response.data.data,
                                page,
                                self.cTop,
                                previousPage
                            );
                        }
                    })
                    .then(() => {
                        self.getColumns();
                        self.requesting = false;
                        self.vSelect = true;
                        if (self.buttonSearchClicked) {
                            self.$toast.success("Filtro aplicado");
                        }
                    })
                    .then(() => {
                        $("#show_registers").val(self.cTop);
                    })
                    .then(() => {
                        self.settingTopScroll();
                    })
                    .catch((error) => {
                        self.$toast.error(error.response.data.message);
                        self.loading = false;
                        self.requesting = false;
                        $("#show_registers").val(self.cTop);
                    });
            }
        },
        extract() {
            const self = this;

            self.loading = true;
            self.extracting = true;

            // filtros
            console.log(self.colu)

            let query = [];
            let haveFilters = false;

            if (self.$store.state.searchHistory.have) {
                var history_filters = JSON.parse(
                    JSON.stringify(self.$store.state.searchHistory.filters)
                );

                //Text
                var t = 0;
                history_filters
                    .filter(function (item) {
                        return item.type == "text";
                    })
                    .forEach((element) => {
                        $("#text" + t).val(element.value);
                        t++;
                    });

                //date
                var d = 0;
                history_filters
                    .filter(function (item) {
                        return item.type == "date";
                    })
                    .forEach((element) => {
                        $("#date" + d).val(element.value);
                        d++;
                    });

                //product
                var p = 0;
                history_filters
                    .filter(function (item) {
                        return item.type == "product";
                    })
                    .forEach((element) => {
                        $("#product" + p).val(element.value);
                        p++;
                    });

                //select
                setTimeout(function () {
                    var s = 0;
                    history_filters
                        .filter(function (item) {
                            return item.type == "selectApi";
                        })
                        .forEach((element) => {
                            if (element.value != "" && element.value != undefined) {
                                self.filtersSelectApi[s].value = element.value;
                            }
                            s++;
                        });
                }, 5000);
            }

            self.filters_copy.forEach((filter) => {
                if (filter.type == "radio" && filter.checked) {
                    query.push({
                        key: filter.name,
                        value: filter.value,
                    });
                } else if (
                    filter.type == "date" &&
                    filter.value != "" &&
                    filter.value != undefined
                ) {
                    var vle = moment(filter.value, "DD/MM/YYYY").format("YYYY-MM-DD");

                    if (
                        filter.name == "created_at" &&
                        [
                            "users/",
                            "customers/",
                            "time_logs/",
                            "licitations/",
                            "orders-not-integrateds/",
                        ].includes(self.endPoint)
                    ) {
                        vle = vle + " 00:00:00," + vle + " 23:59:59";
                    }

                    haveFilters = true;

                    query.push({ key: filter.name, value: vle });
                } else if (
                    filter.type != "radio" &&
                    filter.value != "" &&
                    filter.value != undefined
                ) {
                    haveFilters = true;

                    query.push({
                        key: filter.name,
                        value: filter.value,
                    });
                }
            });

            // filtros fim

            var api = self.$store.state.api + self.endPoint + "extract";

            let columns = [];

            self.local_columns.forEach(item => {
                if (item.reportColumn) {
                    columns.push(item.reportColumn)
                }
            })

            self.extract_data.query = query;
            self.extract_data.order_by = self.selectedOrder;
            self.extract_data.order_type = self.orderType;
            self.extract_data.email = this.$store.getters.user.email;
            self.extract_data.top = self.cTop;
            self.extract_data.columns = columns

            axios
                .post(api, self.extract_data)
                .then((response) => {
                    self.$swal(
                        "Sucesso",
                        "Assim que o relatório estiver pronto, você o receberá no seu e-mail.",
                        "success"
                    );
                })
                .catch((error) => {
                    this.$toast.error("Erro na API");
                    self.loading = false;
                    self.extracting = false;
                })
                .then(() => {
                    self.loading = false;
                    self.extracting = false;
                });
        },
        order_by(field, index) {
            const self = this;

            if (self.ordered_by == field) {
                self.ordered_asc = !self.ordered_asc;
            } else {
                self.ordered_asc = true;
            }

            self.data = self.data.sort(function (a, b) {
                if (a[field] > b[field]) {
                    if (self.ordered_asc) return 1;
                    else return -1;
                }
                if (a[field] < b[field]) {
                    if (self.ordered_asc) return -1;
                    else return 1;
                }

                return 0;
            });

            self.ordered_index = index;
            self.ordered_by = field;
        },
        get_field_value(column, row) {
            if (column.field) {
                let vle = row;
                let splited = column.field.split(".");
                for (let i = 0; i < splited.length; i++) {
                    vle = vle[splited[i]];
                    if (!vle) {
                        break;
                    }
                }
                // if (vle == undefined) {
                //   return "N/A";
                // } else if (vle != undefined) {
                //   if (vle.trim() == "") {
                //     return "N/A";
                //   }
                // }
                return vle;
            } else if (column.callback) {
                return column.callback(row);
            }
        },
        getEntity() {
            const self = this;

            var selects = this.filtersSelectApi;

            selects.forEach((element) => {
                const api =
                    this.$store.state.api + element.model + "?status=1&paginated=false";

                axios
                    .get(api)
                    .then((response) => {
                        var returned = {};
                        returned.data = [
                            {
                                [element.propertyName]: "",
                            },
                        ];
                        returned.data = returned.data.concat(response.data.data);
                        returned.element = element;
                        self.selApi[element.model] = returned;
                    })
                    .catch((error) => {
                        this.$toast.error("Erro na API");
                    });
            });
        },
        async getProducts() {
            const self = this;
            const api = this.$store.state.api + "customers/get-products/";

            await axios
                .post(api, { path: self.$route.path })
                .then((response) => {
                    const newArray = [""].concat(response.data.data);

                    self.products = newArray;
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message);
                    self.loading = false;
                });
        },
        async getBranches() {
            const self = this;
            const api = this.$store.state.api + "branches/get-branches/";

            await axios
                .post(api, { path: self.$route.path })
                .then((response) => {
                    const newArray = [""].concat(response.data);

                    self.branches = newArray;
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message);
                    self.loading = false;
                });
        },
        async getContracts() {
            const self = this;
            const api = this.$store.state.api + "contracts/active-contract-list";

            await axios
                .get(api, { path: self.$route.path })
                .then((response) => {
                    const newArray = [""].concat(response.data.data.ZOOM);

                    self.contracts = newArray;
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message);
                    self.loading = false;
                });
        },

        settingTopScroll() {
            setTimeout(function () {
                $(window).on("scroll load", function () {
                    if ($(".TableCSS table").length > 0) {
                        var tabela_top = $(".TableCSS table").offset().top;
                        var window_top = $(this).scrollTop();

                        $(".TableCSS thead").css({
                            top:
                                tabela_top - window_top <= 0
                                    ? window_top - tabela_top + 120 + "px"
                                    : "0",
                            "z-index": "99999999",
                            background: "white",
                            padding: "10px 0",
                        });
                    }
                });
            }, 500);
        },
        // Novos métodos para o DataTable integrado
        toggleAdvancedFilters() {
            this.showAdvancedFilters = !this.showAdvancedFilters;
        },
        onGlobalSearch() {
            // Debounce para evitar muitas chamadas
            clearTimeout(this.globalSearchTimeout);
            this.globalSearchTimeout = setTimeout(() => {
                // Aplica o valor da busca global ao primeiro filtro de texto disponível
                if (this.filtersText.length > 0) {
                    this.filtersText[0].value = this.globalSearchValue;
                    this.changeFilter(this.filtersText[0].name, { target: { value: this.globalSearchValue } });
                    this.get_data(1);
                }
            }, 500);
        },
        clearGlobalSearch() {
            this.globalSearchValue = "";
            if (this.filtersText.length > 0) {
                this.filtersText[0].value = "";
                this.changeFilter(this.filtersText[0].name, { target: { value: "" } });
                this.get_data(1);
            }
        },
        toggleSortDirection() {
            this.orderType = this.orderType === "ASC" ? "DESC" : "ASC";
            this.changeOrder(this.orderType);
        },
        clearAllFilters() {
            this.globalSearchValue = "";
            this.filters_copy.forEach(filter => {
                filter.value = "";
            });
            this.clearFilters();
        },
        getButtonClass(column, row) {
            const label = column.labelCallback(row);
            if (label === 'Entrega OK / Gerar Canhoto' || label === 'Rastreamento Indisponível') {
                return 'btn btn-info';
            }
            return column.class;
        },
        needsIcon(column, row) {
            const label = column.labelCallback(row);
            return label === 'Entrega OK / Gerar Canhoto' || label === 'Laudo';
        },
        getPaymentClass(column, row) {
            const label = column.labelCallback(row);
            return label === 'Depósito Bancário' ? '' : 'btn btn-info';
        },

        // Método para detectar dispositivos móveis
        detectMobileDevice() {
            this.isMobileDevice = window.innerWidth <= 768;
            
            // Se for dispositivo móvel, ajustar as colunas automaticamente
            if (this.isMobileDevice && this.local_columns.length > 4) {
                // Salvar as colunas originais para não perder a referência
                if (!this._originalColumns) {
                    this._originalColumns = [...this.local_columns];
                }
                
                // Verificar se já estamos em uma versão mobile otimizada
                if (!this._mobileOptimized) {
                    this._mobileOptimized = true;
                    
                    // Priorizar colunas importantes para visualização mobile
                    const priorityColumns = this.local_columns.filter(col => 
                        col.priority === 'high' || 
                        col.field === 'status' || 
                        col.label.includes('Valor') || 
                        col.label.includes('Data') ||
                        col.label.includes('N°')
                    );
                    
                    // Se não houver colunas prioritárias, manter as primeiras 4
                    if (priorityColumns.length < 2) {
                        this.local_columns = this.local_columns.slice(0, 4);
                    } else {
                        // Limitar a 4 colunas no total
                        this.local_columns = priorityColumns.slice(0, 4);
                    }
                    
                    // Mover outras colunas para a lista de ocultas
                    this._hiddenForMobile = this._originalColumns.filter(
                        col => !this.local_columns.includes(col)
                    );
                    
                    // Adicionar às colunas ocultas
                    this.other_columns = [...this.other_columns, ...this._hiddenForMobile];
                }
            } else if (!this.isMobileDevice && this._mobileOptimized) {
                // Restaurar colunas originais quando não for mais mobile
                if (this._originalColumns) {
                    this.local_columns = [...this._originalColumns];
                    
                    // Remover as colunas que foram temporariamente ocultadas para mobile
                    this.other_columns = this.other_columns.filter(
                        col => !this._hiddenForMobile.includes(col)
                    );
                    
                    this._mobileOptimized = false;
                }
            }
        },
    },
    async mounted() {
        let self = this;

        // Inicializar valores
        this._originalColumns = null;
        this._mobileOptimized = false;
        this._hiddenForMobile = [];

        // Detectar se é um dispositivo móvel
        this.detectMobileDevice();
        
        // Adicionar evento de redimensionamento para atualizar a detecção de dispositivo móvel
        window.addEventListener('resize', this.detectMobileDevice);

        self.local_columns = self.columns;
        self.orders.forEach(function (order) {
            if (order.selected) {
                self.selectedOrder = order.column;
            }
        });

        // await this.getProducts();
        // await this.getBranches();
        // await this.getContracts();
        this.getEntity();
        this.get_data();

        console.log('self.filters: ', self.filters)

        self.filters_copy = JSON.parse(JSON.stringify(self.filters));

        if (window.localStorage.getItem('filters_' + self.crudName)) {
            const session = JSON.parse(window.localStorage.getItem('filters_' + self.crudName));

            Object.keys(session).forEach(key => {
                if (self.filters_copy[key]) self.filters_copy[key] = session[key];
            })
        }
    },

    beforeUnmount() {
        // Remover o evento de redimensionamento quando o componente for desmontado
        window.removeEventListener('resize', this.detectMobileDevice);
    },
};
</script>



<style scoped>
/* Container Principal Compacto */
.vs__clear {
    display: none;
}

.modern-table-container {
    padding: 0;
    margin: 0;
}

.modern-header {
    padding: 8px 16px;
    background: #f8f9fa;
    border-bottom: 3px solid #007bff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table-title {
    margin: 0;
}

.btn-modern {
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1.2;
    border-radius: 4px;
    margin: 0 2px;
}

.filters-section {
    padding: 12px 16px;
}

.filters-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
    overflow: hidden;
}

.filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background: #f8f9fa;
    border-bottom: 3px solid #007bff;
    min-height: 40px;
}

.filters-title {
    margin: 0;
}

.active-filters-count {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
}

.filter-group {
    margin-top: 8px;
}

.primary-filters {
    margin-bottom: 12px;
}

.radio-group {
    display: flex;
    gap: 12px;
}

.form-check {
    display: flex;
    align-items: center;
}

.form-check-input {
    margin-top: 2px;
}

.form-check-label {
    margin-left: 4px;
}

.ordering-section {
    margin-top: 8px;
    padding: 8px;
    background: #f8f9fa;
    border-radius: 6px;
}

.order-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.form-group {
    margin-bottom: 8px;
}

.form-label {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
}

.modern-select {
    min-width: 120px;
    height: 32px;
    font-size: 12px;
    padding: 4px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

.radio-direction {
    display: flex;
    gap: 12px;
}

.radio-option {
    display: flex;
    align-items: center;
}

.radio-option input {
    margin: 0;
}

.filters-form {
    margin-top: 8px;
}

.filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 8px;
    margin-bottom: 12px;
}

.filters-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;
}

.btn-modern {
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1.2;
    border-radius: 4px;
}

.loading-section {
    padding: 30px;
    text-align: center;
    background: #f8f9fa;
}

.loading-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #007bff;
    border-top-color: #f8f9fa;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.loading-title {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
}

.loading-progress {
    width: 100%;
    height: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
    border-radius: 5px;
    transition: width 0.5s ease;
}

.error-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.error-icon {
    font-size: 24px;
    color: #dc3545;
}

.error-text {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
}

.content-section {
    padding: 12px 16px;
}

.table-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.controls-left {
    display: flex;
    align-items: center;
}

.results-info {
    font-size: 12px;
    color: #495057;
}

.controls-right {
    display: flex;
    gap: 8px;
}

.table-card {
    overflow-x: auto;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.table-wrapper {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
    font-size: 12px;
    background: #fff;
}

.modern-th {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    padding: 8px 10px;
    text-align: center;
    font-weight: 600;
    font-size: 11px;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.modern-row:nth-child(even) {
    background-color: #f8f9fa;
}

.modern-row:hover {
    background-color: #e9ecef;
}

.modern-td {
    border: 1px solid #dee2e6;
    padding: 6px 8px;
    text-align: center;
    vertical-align: middle;
    font-size: 8px;
    line-height: 1.3;
}

.modern-td.no-data {
    padding: 20px;
}

.empty-state {
    padding: 60px 20px;
    text-align: center;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
}

.empty-content {
    display: contents;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
}

.empty-icon {
    font-size: 48px;
    color: #adb5bd;
    margin-bottom: 8px;
}

.empty-content h4 {
    font-size: 18px;
    color: #495057;
    margin: 0;
}

.empty-content p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
}

.pagination-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    padding: 8px;
    background: #f8f9fa;
    border-radius: 6px;
}

.pagination-info {
    display: flex;
    align-items: center;
    gap: 6px;
}

.records-per-page {
    display: flex;
    align-items: center;
}

.pagination-select {
    min-width: 120px;
    height: 32px;
    font-size: 12px;
    padding: 4px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
}

.pagination-stats {
    font-size: 12px;
    color: #495057;
}

.pagination-nav {
    display: flex;
    align-items: center;
}

.modern-pagination {
    display: flex;
    align-items: center;
}

.page-item {
    display: flex;
    align-items: center;
}

.page-link {
    padding: 4px 8px;
    font-size: 11px;
}

.page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
}

.page-item.active .page-link {
    font-weight: bold;
}

/* Estilos adicionais para modernização */
.modern-input,
.modern-select,
.modern-vselect {
    border: 1px solid #ced4da;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.modern-input:focus,
.modern-select:focus {
    border-color: #007bff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.modern-vselect .vs__dropdown-toggle {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 4px 8px;
    min-height: 32px;
}

.modern-vselect.vs--focused .vs__dropdown-toggle {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Melhorias na tabela */
.modern-table {
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.modern-th:first-child {
    border-top-left-radius: 6px;
}

.modern-th:last-child {
    border-top-right-radius: 6px;
}

.modern-row:last-child .modern-td:first-child {
    border-bottom-left-radius: 6px;
}

.modern-row:last-child .modern-td:last-child {
    border-bottom-right-radius: 6px;
}

/* Estados de loading */
.loading-progress {
    animation: progress-animation 2s ease-in-out infinite;
}

@keyframes progress-animation {
    0% {
        width: 0%;
    }

    50% {
        width: 60%;
    }

    100% {
        width: 100%;
    }
}

/* Elementos clicáveis */
.clickable-field {
    cursor: pointer;
    color: #007bff;
    text-decoration: underline;
}

.clickable-field:hover {
    color: #0056b3;
}

.na-text {
    color: #6c757d;
    font-style: italic;
    font-size: 11px;
}

.field-content {
    word-break: break-word;
    max-width: 200px;
}

/* Alert de colunas ocultas */
.hidden-columns-alert {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    color: #856404;
    padding: 8px 12px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-link {
    background: none;
    border: none;
    color: #007bff;
    text-decoration: underline;
    cursor: pointer;
    font-size: 12px;
}

.btn-link:hover {
    color: #0056b3;
}

/* Transições suaves */
.btn-modern,
.modern-input,
.modern-select,
.page-link {
    transition: all 0.15s ease-in-out;
}

.btn-modern:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modern-row {
    transition: background-color 0.15s ease-in-out;
}

/* Responsividade aprimorada */
@media (max-width: 768px) {
    .modern-table-container {
        padding: 8px;
    }

    .header-content {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }

    .table-title {
        font-size: 18px;
    }

    .filters-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .order-controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .filters-grid {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .filters-actions {
        flex-direction: column;
        gap: 8px;
    }

    .table-controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .controls-right {
        width: 100%;
        justify-content: flex-start;
    }

    .pagination-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .pagination-nav {
        overflow-x: auto;
        padding: 8px 0;
    }

    .modern-pagination {
        white-space: nowrap;
    }

    /* Tabela responsiva */
    .table-wrapper {
        position: relative;
    }

    .table-wrapper::after {
        content: '→ Deslize para ver mais';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.9));
        padding: 4px 8px;
        font-size: 10px;
        color: #6c757d;
        pointer-events: none;
        white-space: nowrap;
    }

    .modern-th,
    .modern-td {
        min-width: 100px;
        font-size: 11px;
        padding: 4px 6px;
    }
}

@media (max-width: 576px) {
    .modern-table-container {
        padding: 4px;
    }

    .filters-section,
    .content-section {
        padding: 8px;
    }

    .modern-header {
        padding: 6px 8px;
    }

    .table-title {
        font-size: 16px;
    }

    .btn-modern {
        padding: 3px 6px;
        font-size: 11px;
    }

    .modern-th,
    .modern-td {
        font-size: 10px;
        padding: 3px 4px;
    }

    .loading-section {
        padding: 20px 8px;
    }

    .spinner {
        width: 32px;
        height: 32px;
    }

    .datatable-loading {
        padding: 30px 8px;
        min-height: 250px;
    }

    .datatable-content {
        min-height: 250px;
    }

    .my-card {
        min-height: 350px;
    }
}

/* Melhorias de acessibilidade */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

/* Estados de focus melhorados */
.btn-modern:focus,
.page-link:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

/* Smooth scrolling para tabela */
.table-wrapper {
    scroll-behavior: smooth;
}

/* Estilos para elementos específicos do Bootstrap */
.form-control {
    border: 1px solid #ced4da !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select {
    border: 1px solid #ced4da !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus,
.form-select:focus {
    border-color: #007bff !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

/* Estilos do modal mantidos */
#modalColumns {
    padding: 15px;
    z-index: 1000;
    max-height: 600px;
    overflow-y: auto;
}

.modal-fade-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.bordered {
    text-align: center;
    border: dotted 1px rgb(160, 160, 160);
    margin: 5px;
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
}

.bordered:hover {
    background-color: #f8f9fa;
    border-color: #007bff;
}

.dragArea {
    min-height: 50px;
    border: 2px dashed #dee2e6;
    border-radius: 4px;
    padding: 8px;
    background-color: #f8f9fa;
    transition: all 0.15s ease-in-out;
}

.dragArea:hover {
    border-color: #007bff;
    background-color: #e3f2fd;
}

.bold {
    font-weight: bold;
}

/* Scrollbar personalizada */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 6px;
    border: 2px solid #f1f1f1;
}

::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* DataTable Container */
.my-container {
    padding: 0;
    background: transparent;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    /* Previne overflow horizontal */
}

/* Card Principal */
.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-height: 700px;
    /* Aumentar altura mínima do card */
    display: flex;
    flex-direction: column;
}

/* Header do DataTable */
.my-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: 1px solid #e9ecef;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.datatable-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.records-summary {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.header-right {
    display: flex;
    gap: 8px;
}

.btn-datatable {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    border: 2px solid white;
    background: transparent;
    color: white;
    transition: all 0.3s ease;
}

.btn-datatable:hover {
    background: white;
    color: #667eea;
    transform: translateY(-1px);
}

/* Toolbar Integrado */
.datatable-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    flex-wrap: wrap;
    gap: 12px;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

/* Toolbar Placeholder */
.toolbar-placeholder {
    opacity: 0.6;
}

.toolbar-placeholder .search-input {
    background-color: #f8f9fa;
    color: #6c757d;
}

.toolbar-placeholder .btn {
    opacity: 0.5;
}

/* Footer Placeholder */
.footer-placeholder {
    opacity: 0.6;
}

.footer-placeholder .page-size-select {
    background-color: #f8f9fa;
    color: #6c757d;
}

.footer-placeholder .pagination-btn {
    opacity: 0.5;
}

.footer-placeholder .pagination-info {
    color: #6c757d;
}

.toolbar-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 0;
    /* Permite que o flex item encolha */
}

.toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    /* Evita que os botões sejam comprimidos excessivamente */
}

/* Busca Global */
.global-search {
    min-width: 200px;
    max-width: 300px;
    flex: 1;
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 12px;
    color: #6c757d;
    z-index: 2;
}

.search-input {
    padding: 8px 12px 8px 36px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 14px;
    width: 100%;
    transition: all 0.3s ease;
}

.search-input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    outline: none;
}

.clear-search {
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.clear-search:hover {
    background: #f8f9fa;
    color: #495057;
}

/* Filtros Rápidos (Tabs) */
.quick-filters {
    display: flex;
    align-items: center;
}

.filter-tabs {
    display: flex;
    background: white;
    border-radius: 6px;
    border: 1px solid #ced4da;
    overflow: hidden;
}

.filter-tab {
    padding: 8px 16px;
    background: white;
    border: none;
    border-right: 1px solid #ced4da;
    color: #495057;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.filter-tab:last-child {
    border-right: none;
}

.filter-tab:hover {
    background: #f8f9fa;
}

.filter-tab.active {
    background: #667eea;
    color: white;
}

/* Controles de Ordenação */
.sort-control {
    display: flex;
    align-items: center;
    gap: 4px;
}

.sort-select {
    min-width: 140px;
    padding: 6px 12px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 13px;
    background: white;
}

.sort-direction {
    padding: 6px 8px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background: white;
    color: #495057;
    font-size: 14px;
    transition: all 0.2s ease;
}

.sort-direction:hover {
    background: #f8f9fa;
}

/* Filtros Avançados */
.filters-toggle {
    position: relative;
    padding: 8px 16px;
    border: 1px solid #667eea;
    border-radius: 6px;
    background: white;
    color: #667eea;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.filters-toggle:hover,
.filters-toggle.active {
    background: #667eea;
    color: white;
}

.filter-count {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #dc3545;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
}

/* Controles de Ação */
.action-controls {
    display: flex;
    gap: 8px;
}

/* Botões mobile responsivos */
.mobile-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
}

@media (max-width: 576px) {
    .mobile-action-btn {
        padding: 6px 10px;
        width: auto;
    }

    .header-right {
        display: flex;
        gap: 8px;
    }
}

.action-controls .btn {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.action-controls .btn:hover {
    transform: translateY(-1px);
}

/* Painel de Filtros Avançados */
.advanced-filters-panel {
    padding: 20px 24px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    animation: slideDown 0.3s ease;
    overflow-x: hidden;
    /* Evita rolagem horizontal */
}

@media (max-width: 768px) {
    .advanced-filters-panel {
        padding: 15px;
        max-height: 80vh;
        /* Altura máxima para evitar problemas em telas pequenas */
        overflow-y: auto;
        /* Permite rolagem vertical */
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        max-height: 0;
        padding: 0 24px;
    }

    to {
        opacity: 1;
        max-height: 300px;
        padding: 20px 24px;
    }
}

.filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.filter-label {
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    margin: 0;
}

.filter-select,
.filter-input {
    padding: 6px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 13px;
    transition: all 0.3s ease;
}

.filter-select:focus,
.filter-input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    outline: none;
}

.filter-vselect {
    font-size: 13px;
}

.filters-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 16px;
    border-top: 1px solid #dee2e6;
}

/* Container Principal Unificado */
.datatable-main-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 500px;
    overflow-x: auto;
    /* Adicionado para permitir rolagem horizontal */
    max-width: 100%;
    position: relative;
    /* Adicionado para posicionamento correto */
}

/* Loading State */
.datatable-loading {
    padding: 60px 24px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    min-height: inherit;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
    /* Limita a largura do conteúdo de loading */
}

.loading-spinner .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-text h4 {
    font-size: 18px;
    color: #495057;
    margin: 0 0 8px 0;
}

.loading-text p {
    color: #6c757d;
    margin: 0;
}

.error-state {
    margin-top: 16px;
}

.error-message {
    color: #dc3545;
    margin: 0 0 12px 0;
}

/* Conteúdo da Tabela */
.datatable-content {
    background: white;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: inherit;
}

.hidden-columns-alert {
    background: #fff3cd;
    border: none;
    border-left: 4px solid #ffc107;
    color: #856404;
    padding: 12px 24px;
    margin: 0;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-link {
    background: none;
    border: none;
    color: #667eea;
    text-decoration: underline;
    cursor: pointer;
    font-size: 13px;
    padding: 0;
}

.btn-link:hover {
    color: #495057;
}

/* Tabela */
.table-responsive {
    overflow-x: auto;
    max-width: 100%;
    box-sizing: border-box;
    flex: 1;
    min-height: 400px;
    display: flex;
    flex-direction: column;
}

.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    background: white;
    table-layout: auto;
    /* Permite que as colunas se ajustem ao conteúdo */
}

.my-header-row {
    background: #f8f9fa;
}

.datatable-th {
    padding: 10px 10px;
    text-align: center;
    font-weight: 600;
    color: #495057;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0px;
    border-bottom: 2px solid #e9ecef;
    white-space: nowrap;
}

/* Cabeçalho fixo apenas no desktop */
@media (min-width: 769px) {
    .datatable-th {
        position: sticky;
        top: 0;
        background: #f8f9fa;
        z-index: 10;
    }
    
    /* Garante que o container da tabela tenha scroll vertical */
    .table-responsive {
        max-height: 70vh;
        overflow-y: auto;
    }
    
    /* Sombra sutil no cabeçalho para indicar que está fixo */
    .my-header-row {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
}

/* Otimizações para telas grandes */
@media (min-width: 1024px) {
    .table-responsive {
        max-height: 75vh;
    }
    
    .datatable-th {
        font-size: 13px;
        padding: 12px 10px;
    }
}

/* Otimizações para telas muito grandes */
@media (min-width: 1440px) {
    .table-responsive {
        max-height: 80vh;
    }
    
    .datatable-th {
        font-size: 14px;
        padding: 14px 12px;
    }
}

/* Otimizações para telas ultra-wide */
@media (min-width: 1920px) {
    .table-responsive {
        max-height: 85vh;
    }
    
    .datatable-th {
        font-size: 15px;
        padding: 16px 14px;
    }
}

.datatable-row {
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f3f4;
}

.datatable-row:hover {
    background: #f8f9fa;
}

.datatable-td {
    padding: 18px 24px;
    color: #495057;
    font-size: 13px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f3f4;
    word-break: keep-all;
    /* Mantém palavras inteiras */
    overflow-wrap: normal;
    white-space: nowrap;
    /* Evita quebra de linha */
    min-width: 120px;
    /* Garante largura mínima para as células */
    line-height: 1.5;
}

.field-value {
    word-break: keep-all;
    white-space: nowrap;
    line-height: 1.4;
}

.na-value {
    color: #adb5bd;
    font-style: italic;
}

.clickable-field {
    color: #667eea;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.2s ease;
}

.clickable-field:hover {
    color: #495057;
}

/* Estado Vazio */
.empty-state {
    padding: 60px 20px;
    text-align: center;
    background: white;
}

.empty-content {
    display: contents;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.empty-icon {
    font-size: 48px;
    color: #adb5bd;
}

.empty-content h4 {
    font-size: 18px;
    color: #495057;
    margin: 0;
}

.empty-content p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
}

/* Footer com Paginação */
.datatable-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

.footer-left,
.footer-center,
.footer-right {
    display: flex;
    align-items: center;
}

.items-per-page {
    display: flex;
    align-items: center;
    gap: 8px;
}

.items-per-page label {
    font-size: 13px;
    color: #495057;
    margin: 0;
}

.page-size-select {
    padding: 4px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 13px;
    background: white;
    min-width: 70px;
}

.pagination-info {
    font-size: 13px;
    color: #495057;
    font-weight: 500;
}

/* Navegação de Paginação */
.pagination-nav {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
    /* Permite que os botões quebrem em telas menores */
}

@media (max-width: 480px) {
    .pagination-nav {
        justify-content: center;
        gap: 2px;
    }

    .pagination-btn {
        min-width: 28px;
        height: 28px;
        padding: 3px;
        font-size: 12px;
    }
}

.pagination-btn {
    padding: 6px 10px;
    border: 1px solid #ced4da;
    background: white;
    color: #495057;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease;
    min-width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #adb5bd;
}

.pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-pages {
    display: flex;
    gap: 2px;
}

.page-number.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

.page-number.active:hover {
    background: #667eea;
    border-color: #667eea;
}

.pagination-ellipsis {
    padding: 6px 4px;
    color: #6c757d;
    font-size: 13px;
    display: flex;
    align-items: center;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        padding: 0;
    }

    .my-header {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        padding: 16px;
    }

    .header-left {
        width: 100%;
    }

    .datatable-toolbar {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding: 12px 16px;
    }

    .toolbar-left,
    .toolbar-right {
        width: 100%;
        justify-content: flex-start;
    }

    .global-search {
        min-width: unset;
        width: 100%;
        max-width: 100%;
    }

    .filters-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .datatable-footer {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding: 12px 16px;
    }

    .footer-left,
    .footer-center,
    .footer-right {
        width: 100%;
        justify-content: center;
    }

    .datatable-th,
    .datatable-td {
        padding: 14px 18px;
        font-size: 13px;
    }

    .pagination-nav {
        justify-content: center;
        width: 100%;
    }
}

@media (max-width: 576px) {
    .my-container {
        padding: 0;
    }

    .datatable-title {
        font-size: 20px;
    }

    .records-summary {
        font-size: 12px;
        padding: 2px 8px;
    }

    .datatable-th,
    .datatable-td {
        padding: 12px 16px;
        font-size: 12px;
    }

    .datatable-loading {
        padding: 40px 16px;
        min-height: 300px;
    }

    .datatable-content {
        min-height: 300px;
    }

    .my-card {
        min-height: 400px;
    }

    .pagination-btn {
        min-width: 28px;
        height: 28px;
        padding: 4px 6px;
        font-size: 12px;
    }
}

/* Modal styles mantidos */
#modalColumns {
    padding: 15px;
    z-index: 1000;
    max-height: 600px;
    overflow-y: auto;
}

.modal-fade-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.bordered {
    text-align: center;
    border: dotted 1px rgb(160, 160, 160);
    margin: 5px;
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
}

.bordered:hover {
    background-color: #f8f9fa;
    border-color: #007bff;
}

.dragArea {
    min-height: 50px;
    border: 2px dashed #dee2e6;
    border-radius: 4px;
    padding: 8px;
    background-color: #f8f9fa;
    transition: all 0.15s ease-in-out;
}

.dragArea:hover {
    border-color: #667eea;
    background-color: #e3f2fd;
}

.bold {
    font-weight: bold;
}

/* Melhorias para visualização em dispositivos móveis */
@media (max-width: 768px) {
    .datatable-main-content {
        min-height: 400px;
    }

    .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        /* Para rolagem suave em iOS */
        width: 100%;
        position: relative;
    }

    .datatable {
        width: 100%;
        min-width: 500px;
        /* Reduzindo a largura mínima para melhor adaptação em mobile */
        table-layout: fixed;
        /* Força larguras iguais entre colunas */
    }

    /* Indicador de rolagem lateral */
    .table-responsive::after {
        content: '← Deslize →';
        position: absolute;
        bottom: 10px;
        right: 10px;
        background: rgba(102, 126, 234, 0.8);
        color: white;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        pointer-events: none;
        animation: fadeInOut 2s ease-in-out infinite;
        z-index: 100;
    }

    @keyframes fadeInOut {

        0%,
        100% {
            opacity: 0.8;
        }

        50% {
            opacity: 0.3;
        }
    }

    /* Ajustes para o toolbar em mobile */
    .datatable-toolbar {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .toolbar-left,
    .toolbar-right {
        width: 100%;
    }

    .global-search {
        max-width: 100%;
        width: 100%;
    }

    .action-controls {
        width: 100%;
        justify-content: space-between;
    }

    /* Ajustes para o footer em mobile */
    .datatable-footer {
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .footer-left,
    .footer-center,
    .footer-right {
        width: 100%;
        justify-content: center;
    }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 480px) {
    .datatable-main-content {
        min-height: 300px;
    }

    .datatable-th,
    .datatable-td {
        padding: 8px;
        font-size: 11px;
    }

    .my-header {
        padding: 12px;
    }

    .datatable-title {
        font-size: 18px;
    }

    .records-summary {
        font-size: 11px;
    }

    .btn-datatable {
        padding: 6px 10px;
        font-size: 12px;
    }
}

/* Estilos para o helper de rolagem móvel */
.mobile-scroll-helper {
    background-color: #fff3cd;
    color: #856404;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    border-left: 4px solid #ffc107;
}

.mobile-scroll-helper i {
    font-size: 14px;
}

    /* Ajustes para células da tabela em dispositivos móveis */
@media (max-width: 768px) {
    /* Remove o cabeçalho fixo em mobile */
    .datatable-th {
        position: static;
        background: #f8f9fa;
    }
    
    /* Remove a altura máxima e scroll vertical em mobile */
    .table-responsive {
        max-height: none;
        overflow-y: visible;
    }
    
    .datatable-td {
        white-space: nowrap;
        max-width: 140px;
        /* Aumentando para dar mais espaço */
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 12px 10px !important;
        /* Aumentando o padding */
        font-size: 12px !important;
        /* Mantendo um tamanho de fonte legível */
        word-break: keep-all;
        /* Mantém palavras inteiras em mobile */
    }

    /* Exibir conteúdo completo ao tocar na célula */
    .datatable-td:active .field-value,
    .datatable-td:focus .field-value,
    .datatable-td:hover .field-value {
        white-space: normal;
        word-break: keep-all;
        max-width: none;
        position: relative;
        z-index: 100;
        background-color: #f8f9fa;
        padding: 8px;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    /* Manter espaço adequado entre as colunas */
    .datatable-th {
        padding: 12px 10px !important;
        font-size: 12px !important;
    }

    /* Forçar o conteúdo a ficar dentro da célula */
    .field-value {
        width: 100%;
        display: block;
        white-space: nowrap;
        word-break: keep-all;
    }
}

/* Estilização adicional para dispositivos móveis muito pequenos */
@media (max-width: 480px) {
    /* Remove o cabeçalho fixo em telas muito pequenas */
    .datatable-th {
        position: static;
        background: #f8f9fa;
    }
    
    /* Remove a altura máxima e scroll vertical em telas muito pequenas */
    .table-responsive {
        max-height: none;
        overflow-y: visible;
    }
    
    /* Tabela empilhada para telas muito pequenas */
    .datatable {
        min-width: 400px; /* Ainda menor para telas muito pequenas */
    }
    
    /* Feedback visual para swipe horizontal */
    .table-responsive::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        width: 20px;
        background: linear-gradient(to right, transparent, rgba(255,255,255,0.7));
        pointer-events: none;
        z-index: 10;
    }
    
    /* Reduz ainda mais o padding e tamanho da fonte */
    .datatable-td, .datatable-th {
        padding: 6px 4px !important;
        font-size: 10px !important;
    }
    
    /* Ajusta a largura das células para telas muito pequenas */
    .datatable-td {
        max-width: 120px;
        min-width: 80px;
    }
    
    /* Melhora a visualização de números e valores */
    .datatable-td:nth-child(3),
    .datatable-td:nth-child(4),
    .datatable-td:nth-child(5) {
        text-align: center;
    }
}

/* Melhorias para tablets */
@media (min-width: 481px) and (max-width: 768px) {
    /* Remove o cabeçalho fixo em tablets */
    .datatable-th {
        position: static;
        background: #f8f9fa;
    }
    
    /* Remove a altura máxima e scroll vertical em tablets */
    .table-responsive {
        max-height: none;
        overflow-y: visible;
    }
    
    .datatable {
        min-width: 450px;
    }
    
    /* Melhora a visualização de números e valores */
    .datatable-td:nth-child(3),
    .datatable-td:nth-child(4),
    .datatable-td:nth-child(5) {
        text-align: center;
    }
}
</style>
